import React from "react";
import {
  FaInstagram,
  FaWhatsapp,
  FaTelegramPlane,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowUp,
} from "react-icons/fa";
import { HiDevicePhoneMobile } from "react-icons/hi2";
import "./footer.css";

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      className="footer"
      role="contentinfo"
      aria-label="پاورقی سایت گوهر صدف دریا"
      style={{ cursor: "url('/images/shell.png'), auto" }}
    >
      {/* decorative SVG wave — keeps separation from page */}
      <svg
        className="footer-wave"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        aria-hidden
      >
        <path
          d="M0,32 C150,80 350,0 600,24 C850,48 1050,80 1200,32 L1200,120 L0,120 Z"
          fill="#cbedea"
          opacity="0.95"
        />
      </svg>

      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-section footer-card footer-company">
          <div className="company-head">
            <div className="logo-badge" aria-hidden>
              <img src="/images/logo.png" alt="گوهر صدف دریا" className="logo-img" />
            </div>
            <h3 className="footer-logo">گوهر صدف دریا</h3>
          </div>
          <div className="footer-text">
            <p>
              گوهر صدف دریا با هدف زنده نگه‌داشتن هنرهای دستی ایرانی آغاز به کار کرد. هر محصولی که ارائه می‌دهیم، بازتابی از تاریخ، عشق و مهارت دستان هنرمندان ماست. ما باور داریم که صنایع دستی نه‌تنها یادگار نسل‌های گذشته‌اند، بلکه پلی میان فرهنگ دیروز و زندگی امروز محسوب می‌شوند.
              در گوهر صدف، تلاش ما بر این است که با بهره‌گیری از طرح‌های اصیل و در عین حال نگاهی نوآورانه، آثاری خلق کنیم که زیبایی و اصالت ایرانی را در کنار کاربرد روزمره به همراه داشته باشند. هر قطعه، داستانی در دل خود دارد؛ داستانی از تلاش هنرمندانی که با عشق به فرهنگ و سرزمین خود، اثری ماندگار می‌آفرینند.
            </p>
          </div>
        </div>

        {/* Most visited */}
        <div className="footer-section footer-card footer-links" aria-labelledby="most-visited-title">
          <h4 id="most-visited-title" className="section-title">صفحات پربازدید</h4>
          <ul className="most-visited" role="list">
            <li><a href="/products">محصولات</a></li>
            <li><a href="/products/turquoise-copper-dishes">ظروف فیروزه‌کوبی</a></li>
            <li><a href="/products/ghalamzani-dishes-art">ظروف قلم‌زنی</a></li>
            <li><a href="/blogs">بلاگ</a></li>
            <li><a href="/team">درباره ما</a></li>
            <li><a href="/contact">تماس با ما</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section footer-card footer-contact" aria-labelledby="contact-title">
          <h4 id="contact-title" className="section-title">تماس با ما</h4>

          <div className="contact-row">
            <FaMapMarkerAlt className="contact-icon" aria-hidden />
            <div className="contact-text">تهران، خیابان ولیعصر، نبش کوچه بالاور، مرکز خدمات توسعه بازار پارک علم و فناوری دانشگاه امیرکبیر
            </div>
          </div>

          <div className="contact-row">
            <FaPhone className="contact-icon" aria-hidden />
            <a className="contact-text" href="tel:02144287186">۰۲۱-۴۴۲۸۷۱۸۶</a>
          </div>

          <div className="contact-row">
            <HiDevicePhoneMobile className="contact-icon" aria-hidden />
            <a className="contact-text" href="tel:09123796943">۰۹۱۲۳۷۹۶۹۴۳</a>
          </div>

          <div className="contact-row">
            <FaEnvelope className="contact-icon" aria-hidden />
            <a className="contact-text" href="mailto:info@goharesadaf.ir">
              info@goharesadaf.ir
            </a>
          </div>

          <div className="social-links" role="list" aria-label="شبکه‌های اجتماعی">
            <a className="social-btn" href="https://instagram.com/yourpage" target="_blank" rel="noopener noreferrer" aria-label="اینستاگرام">
              <FaInstagram />
              <span className="sr-only">اینستاگرام</span>
            </a>
            <a className="social-btn" href="https://wa.me/989123456789" target="_blank" rel="noopener noreferrer" aria-label="واتس‌اپ">
              <FaWhatsapp />
              <span className="sr-only">واتس‌اپ</span>
            </a>
            <a className="social-btn" href="https://t.me/yourpage" target="_blank" rel="noopener noreferrer" aria-label="تلگرام">
              <FaTelegramPlane />
              <span className="sr-only">تلگرام</span>
            </a>
          </div>
        </div>

      </div>

      {/* Sub-footer */}
      <div className="footer-bottom">
        <p className="copyright">&copy; {new Date().getFullYear()} کلیه حقوق این وب سایت متعلق به مسیر امید افرا می باشد.</p>

        <div className="bottom-actions">
          <button className="back-to-top" onClick={scrollToTop} aria-label="بازگشت به بالا">
            <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
